import { createContext } from 'react';
import { DetailedUser } from 'src/types/user';

export const LoginUserContext = createContext<DetailedUser>({});
